<app-team-privacy-settings  [optInActivitiesControl]="f.optInActivities" [optInPepActivitiesControl]="f.optInPepActivities"></app-team-privacy-settings>
<app-team-privacy-toggle></app-team-privacy-toggle>
<div *ngIf="teamMember.isAdmin" class="margin-top-half display-flex justify-content-center">
    <button type="button" class="button button--secondary button--small icon-close button-with-icon" (click)="confirmDeactivate()">
        {{ 'TEXT_DEACTIVATETEAM' | translate}}
    </button>
</div>
